/* eslint-disable @foundershub/fluent */
// Disable on previous line since this page does not follow the general FH design.
import * as React from 'react';
import { Body1, Link, makeStyles, tokens } from '@fluentui/react-components';
import { defineMessage, useIntl } from 'react-intl';
import { SkipToMain } from '../components';

interface Props {
  children: React.ReactNode;
}

export default function ReferralLayout({ children }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SkipToMain id="main" />

      <main id="main" className={classes.content}>
        {children}
      </main>

      <Footer />
    </div>
  );
}

// We use a custom footer for this page only
function Footer() {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <nav className={classes.nav}>
        <div role="list" className={classes.links}>
          <div role="listitem">
            <Link
              className={classes.link}
              href="https://www.microsoft.com/en-US/legal/intellectualproperty/trademarks/usage/general"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Body1>{intl.formatMessage(helpLabel)}</Body1>
            </Link>
          </div>
          <div role="listitem">
            <Link
              className={classes.link}
              href="https://www.microsoft.com/en-US/legal/intellectualproperty/copyright"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Body1>{intl.formatMessage(termsLabel)}</Body1>
            </Link>
          </div>
          <div role="listitem">
            <Link
              className={classes.link}
              href="https://go.microsoft.com/fwlink/?LinkId=521839"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Body1>{intl.formatMessage(privacyLabel)}</Body1>
            </Link>
          </div>
          <div role="listitem">
            <Link
              className={classes.link}
              href="https://support.microsoft.com/supportrequestform/354fe60a-ba6d-92ad-208a-6a41387aa9d8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Body1>{intl.formatMessage(feedbackLabel)}</Body1>
            </Link>
          </div>
        </div>
      </nav>
    </footer>
  );
}

const helpLabel = defineMessage({
  defaultMessage: 'Get help',
  description: 'footer get help link text',
});
const termsLabel = defineMessage({
  defaultMessage: 'Terms of Use',
  description: 'footer terms link text',
});
const privacyLabel = defineMessage({
  defaultMessage: 'Privacy and cookies',
  description: 'footer privacy link text',
});
const feedbackLabel = defineMessage({
  defaultMessage: 'Give Feedback',
  description: 'footer feedback link text',
});

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    background: 'linear-gradient(to right, #0F7FD9, #1583DA, #50E6FF, #AE71F1)',
    overflowX: 'hidden',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    background: 'linear-gradient(to top, rgba(250,250,250, 1), rgba(255, 255, 255, 0.75))',
  },
  footer: {
    background: 'rgba(250,250,250, 1)',
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '42px',
  },
  nav: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
  },
  links: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexGrow: 1,
    maxWidth: '460px',
  },
  link: {
    color: '#424242',
    ':hover': {
      textDecoration: 'none',
      color: tokens.colorPaletteBlueBorderActive,
    },
    '&:focus-visible': {
      outline: '1.5px solid', // Customize the box style as needed
      outlineOffset: '1px',
      textDecoration: 'none', // Remove default underline
      boxShadow: '0 0 0 1px',
    },
  },
});
